import { Box, LinearProgress, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  getPasswordStrength,
  STRENGTH_COLORS,
  STRENGTH_LABEL_KEYS,
} from "../../utils/passwordStrength";

const PasswordStrengthBar = ({ password }) => {
  const { t } = useTranslation();
  const { score } = getPasswordStrength(password);

  if (!password) {
    return null;
  }

  const progress = ((score + 1) / 5) * 100;
  const color = STRENGTH_COLORS[score] || STRENGTH_COLORS[0];
  const labelKey = STRENGTH_LABEL_KEYS[score] || STRENGTH_LABEL_KEYS[0];

  return (
    <Box sx={{ mt: 1 }}>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: 8,
          borderRadius: 1,
          bgcolor: "grey.200",
          "& .MuiLinearProgress-bar": {
            bgcolor: color,
            borderRadius: 1,
          },
        }}
      />
      <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: "block" }}>
        {t("accountSettings.passwordStrength.label")}: {t(labelKey)}
      </Typography>
    </Box>
  );
};

export default PasswordStrengthBar;
